export default __webpack_public_path__ + "static/media/her3.2a3714fa.png";